import Keycloak from 'keycloak-js';

import Environment from '../environment/Environment';

let kc = Keycloak('./resources/keycloak.json');

let userName;
let userDisplayName;
let token;
let refreshToken: string;

const initKeycloak = (onAuthenticatedCallback) => {
  kc.init({
    onLoad: 'login-required'
  })
    .then((authenticated) => {
      if (authenticated) {
        kc.loadUserProfile().then(profile => {
          token = kc.idToken;
          refreshToken = kc.refreshToken || '';
          userName = kc.idTokenParsed?.sub;
          userDisplayName = profile.username;
          sessionStorage.setItem('userName', userName);
          sessionStorage.setItem('userDisplayName', userDisplayName);
          sessionStorage.setItem('token', token);
          sessionStorage.setItem('refreshToken', refreshToken);
          onAuthenticatedCallback();
        });
      }
      if (!authenticated) {
        console.log('user is not authenticated..!');
      }
    })
    .catch(console.error);
};

const logout = () => {
  sessionStorage.removeItem('userName');
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('refreshToken');
  sessionStorage.removeItem('isAdminUser');
  kc.clearToken();
  kc.logout({redirectUri: `${Environment.LOGOUT_URL}`});
};

const UserService = {
  initKeycloak, logout
};

export default UserService;
